import { cn } from '../lib/utils';

/**
 * How many things a tab holds, after its label: Users' plan tabs, Support's
 * views. Muted on an unselected tab; on the selected (inverse) tab it takes
 * the label's colour so it stays readable. Put it directly inside the
 * TabsTrigger, which is what the selected style keys on.
 *
 * Not for unread counts: those are UnreadBadge, red, and hidden at zero.
 */
export function TabCount({ count, className }) {
  if (count === undefined || count === null) return null;
  return (
    <span
      className={cn(
        'ml-2 tabular-nums text-muted-foreground [[data-state=active]>&]:text-inverse-foreground',
        className
      )}
    >
      {count}
    </span>
  );
}
